//
//
//
//
//

    export default {
        props:{
            datainfos: {
                type:Object,
            }
        },
        name: "recordvideo",
        data(){
            return{
                queryinfo:{}
            }
        },
        mounted() {
            this.queryinfo = this.datainfos
            console.log('465468465321*-/*-/123')
            window.videoRecordInfo = this.VideoRecordInfo;     //视频录制挂载方法
        },
        methods:{
            //调用app
            clickFunc(item) {
                // alert(item.contracttitle);
                const u = navigator.userAgent;
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if (isiOS) {
                    //vue调用iOS方法，且传值给iOS （iOS 方法名为 onItemClick）
                    window.webkit.messageHandlers.onItemClick.postMessage('ios');
                } else {
                    //vue调用Android方法，且传值给Android （Android方法名为 onItemClick）
                    // $App.onItemClick('000');
                    window.android.onItemClick('android');
                }
            },
            //视频录制--接收app传来的参数
            VideoRecordInfo(res){
                console.log(res)
                //this.queryinfo.recordVideoUrl = res.recordVideoUrl
                //接收传来的视频录制地址recordVideoUrl，调用submitRecordVideoUrlfunction() 提交记录
                //this.submitRecordVideoUrlfunction()
            },
            //提交视频录制记录接口
            submitRecordVideoUrlfunction(){
                hebeiSDK.submitRecordVideoUrl({
                    params:{
                        "userCode": this.queryinfo.courseCode,
                        "groupCode": this.queryinfo.groupCode,
                        "courseCode": this.queryinfo.courseCode,
                        "lessonCode": this.queryinfo.lessonCode,
                        "vodCode" : this.queryinfo.vodCode,
                        "recordVideoUrl" : this.queryinfo.recordVideoUrl  // 视频录制的地址
                    }
                }).then((res)=>{
                    console.log(res)
                })
            },
        }
    }



// WEBPACK FOOTER //
// ./src/components/recordvideo.vue